export default __webpack_public_path__ + "static/media/powerladder_policy.c5a8b6e7.png";